import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { GardenLogo } from './BrandAssets';

const { FiGrid, FiBookOpen, FiClock, FiMap, FiArchive, FiZap, FiUser } = FiIcons;

const navItems = [
  { id: 'dashboard', icon: FiGrid, label: 'Telemetry' },
  { id: 'library', icon: FiBookOpen, label: 'Flora Archive' },
  { id: 'schedule', icon: FiClock, label: 'Rhythm Sync' },
  { id: 'layout', icon: FiMap, label: 'Zone Map' },
  { id: 'supplies', icon: FiArchive, label: 'Inventory' },
  { id: 'demo', icon: FiZap, label: 'Demo' },
];

export default function Navigation({ activeTab, setActiveTab }) {
  return (
    <>
      <aside className="hidden md:flex flex-col w-64 bg-garden-dark border-r border-garden-base h-screen pt-6 pb-4">
        <div className="px-6 mb-8 flex items-center gap-3">
          <GardenLogo className="w-10 h-10" />
          <div>
            <h1 className="text-lime font-bold tracking-tight text-lg leading-tight">GardenGlide</h1>
            <p className="text-clay-dark text-[10px] font-mono tracking-widest uppercase">Bio-Cockpit v4.3</p>
          </div>
        </div>

        <nav className="flex-1 px-4 space-y-1.5 overflow-y-auto scrollbar-hide">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group ${
                activeTab === item.id
                  ? 'bg-garden-base text-lime border border-lime/20 shadow-[0_0_20px_rgba(163,230,53,0.05)]'
                  : 'text-clay-muted hover:bg-garden-base/50 hover:text-clay'
              }`}
            >
              <SafeIcon icon={item.icon} className={activeTab === item.id ? 'text-lime glow-text' : 'group-hover:text-lime/70'} />
              <span className="text-sm font-semibold tracking-wide">{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="px-4 mt-auto">
          <div className="bg-garden-darkest/50 rounded-2xl p-4 border border-garden-base">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-garden-light flex items-center justify-center border border-garden-base">
                <SafeIcon icon={FiUser} className="text-clay" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold text-clay truncate">Pilot_Zero_One</p>
                <p className="text-[10px] text-lime font-mono">STATUS: SYNCED</p>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-garden-dark border-t border-garden-base pb-safe z-50 overflow-x-auto scrollbar-hide">
        <div className="flex justify-around items-center h-16 px-4 min-w-max gap-6">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`flex flex-col items-center justify-center px-1 h-full space-y-1 transition-colors ${
                activeTab === item.id ? 'text-lime' : 'text-clay-muted'
              }`}
            >
              <SafeIcon icon={item.icon} className={`text-xl ${activeTab === item.id ? 'glow-text' : ''}`} />
              <span className="text-[9px] font-mono uppercase tracking-widest">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
}